const warn = (...attrs) => {
  return false;
};
export { warn as w };
//# sourceMappingURL=console.js.map
